const production = true;

export const CONFIG = {
  // 172.31.3.10
  //http://sandbox.readycashng.com:8080/rc/rest/
        laravelServer: (production === true) ? 'https://readycash.app/api/' : 'http://192.168.1.101:8000/api/',
      //  laravelServer: production ? 'http://192.168.1.101:8000/api/' : 'http://192.168.1.101:8000/api/',
        readycashServer: production ? 'https://www.readycash.com.ng:6443/rc/rest/' : 'http://sandbox.readycashng.com:8080/rc/rest/',
        scannerKey: '533c5006555305070353045239525a0e4a1353165f4153404c44510753415351115c090d5a5c5a523a0307035757090c555756',
        laravelUrl: 'https://readycash.app',
        laravelUrlTest: 'http://192.168.1.101:8000'
};



// WEBPACK FOOTER //
// ./src/config/config.ts